<template>
  <div>
    <span class="text-nowrap" v-if="item.id">
      <b-link :to="{name: 'ShippingsEdit', params: {id: item.id}}" target="_blank">{{item.id | uuid }}</b-link>
      <a href="#" @click.prevent="copyToClipboard(item.id)" class="text-secondary" :title="$gettext('Copy to Clipboard')">
        <font-awesome-icon :icon="['far', 'copy']" />
      </a>
    </span>
  </div>
</template>

<script>
export default {
  name: 'ItemsShippingHistoryListItemId',
  props: {
    item: {
      type: Object,
      required: true
    }
  }
}
</script>
